interface IBudgetTitleProps {
  title: string;
}

const BudgetTitle = (props: IBudgetTitleProps) => {
  return (
    <div className="text-size-h4 font-bold mb-4 px-6">
      {props.title}
    </div>
  );
};

export default BudgetTitle;

